import { FaEdit, FaTrash } from "react-icons/fa";
import { eventCol } from "../interface/types";
import { IoInformationCircle, IoInformationCircleOutline } from "react-icons/io5"
import dashBoardIcon from "../assets/svg/Nav/dashBoardIcon.svg";
import userMangeIcon from "../assets/svg/Nav/userMangeIcon.svg";
import enqueryIcon from "../assets/svg/Nav/enqueryIcon.svg";
import eventIcon from "../assets/svg/Nav/eventIcon.svg";
import supplierIcon from "../assets/svg/Nav/supplierIcon.svg";
import venueIcon from "../assets/svg/Nav/venueIcon.svg";
import customerIcon from "../assets/svg/Nav/customerIcon.svg";
import reportIcon from "../assets/svg/Nav/reportIcon.svg";
import paymentIcon from "../assets/svg/Nav/paymentIcon.svg";
import settingIcon from "../assets/svg/Nav/settingIcon.svg";

type UserData = {
  id: number;
  userName: string;
  emailAddress: string;
  phoneNumber: number;
  role: string;
  joinedDate: string;
  Actions?: string;
};

type EventStatus = {
  id: number;
  eventName: string;
  eventDate: string;
  clientName: string;
  eventBudget: number;
  assignedTeamMember: string;
  status: string;
  Actions?: string;
};
type SalesPerformanceStatus = {
  id: number;
  eventName: string;
  eventDate: string;
  customerName: string;
  eventBudget: number;
  assignedSalesPersonName: string;
  status: string;
  Actions?: string;
};

type HandledEvent = {
  id: number;
  eventName: string;
  totalBudet: number;
  totalProfit: number;
  proposalCount: number;
  contractSentCount: number;
};

interface ReportProfit {
  id: number;
  eventName: string;
  revenue: number;
  expensive: number;
  profit: number;
  loss: number;
}


export const venuetemplateAccordianDetail = [
  {
    name: "venueRequirements",
    label: "Venue requirements",
  },
  {
    name: "cateringRequirements",
    label: "Catering Requirements",
  },
  {
    name: "entertainmentReq",
    label: "Entertainment Requirement",
  },
  {
    name: "audio",
    label: "Audio Visual Requirement",
  },
  {
    name: "logistics",
    label: "Logistics Requirement",
  },
];



export const eventDetailsInVenueTemplate = {
  "Enquiry Reference": "EKA15692",
  "Number of Guests": "Approximately 750-800 (70% adults, 30% under 18)",
  "Notes": "Including A/V equipment,catering options,etc..",
  "Preferred Dates": "Saturday,June 21,2025",
  "Timings" :"12:00 PM to 4:00 PM",
  "Backup Dates" : "Saturday,June 28,2025",
  "Seating Style" :"standing"
};
export const eventDetailsInSupplierTemplate = {
  "Event Type": "Birthday",
  "Number of Guests": "Approximately 750-800 (70% adults, 30% under 18)",
  "Notes": "Including A/V equipment,catering options,etc..",
  "Preferred Dates": "Saturday,June 21,2025",
  "Location":"Spain",
  "Timings" :"12:00 PM to 4:00 PM",
};

export const eventFollowUpvenueTemplate = {
  "Availability": "18/11/2024, 19/11/2024",
  "Capacity ": " 400 Adults, 50 Kids",
  "Package inclusions": " including A/V equipment, catering options, etc.",
  "Budget": "£20,000",
};

export const convertEditedDetailsToTableRows = (editedDetails: string) =>{
  const parser = new DOMParser();
  const doc = parser.parseFromString(editedDetails, 'text/html');
  
  const rows = Array.from(doc.querySelectorAll("p")).map((p) => {
    const strongElement = p.querySelector("strong");
    if (!strongElement) return '';
    
    const key = strongElement.textContent?.trim() || '';
    const value = p.textContent?.replace(`${key}:`, '').trim() || '';
    
    return `
      <tr>
        <td style="font-size:13px; font-weight:500; color:#282828b2; padding-bottom:10px;">${key}</td>
        <td style="font-size:13px; font-weight:600; color:#282828b2; padding-bottom:10px;">:</td>
        <td style="font-size:13px; font-weight:500; color:#282828; padding-bottom:10px;">${value}</td>
      </tr>
    `;
  });

  return rows.join("\n");
}


export const venueTabDetailsInEnquiryRow1 = [
  {
    id: 1,
    field: "Venue Name",
    value: "-",
  },
  {
    id: 2,
    field: "Venue Address",
    value: "-",
  },
  {
    id: 3,
    field: "Venue Contact",
    value: "-",
  },
  {
    id: 4,
    field: "Venue Contract Signed",
    value: "-",
  },
];

export const clientTemplateProposalListCol: eventCol[] = [
  {
    id: "proposalId",
    label: "Proposal ID",
  },
  { id: "dateSent", label: "Date/Time" },
  { id: "status", label: "Status" },
  { id: "action", label: "Action" },
];

export const clientTemplateProposalListRow = [
  {
    id: 1,
    proposalId: "134682-8",
    date: "2/Feb/25-3:14PM",
    status: "Accepted",
    action: "View",
  },

  {
    id: 2,
    proposalId: "134682-8",
    date: "2/Feb/25-3:14PM",
    status: "Accepted",
    action: "View",
  },
  {
    id: 3,
    proposalId: "134682-8",
    date: "2/Feb/25-3:14PM",
    status: "Rejected",
    action: "View",
  },
  {
    id: 4,
    proposalId: "134682-8",
    date: "2/Feb/25-3:14PM",
    status: "Rejected",
    action: "View",
  },
  {
    id: 5,
    proposalId: "134682-8",
    date: "2/Feb/25-3:14PM",
    status: "Accepted",
    action: "View",
  },
];

// export const bookingDetailsData = {
//   Client: "Live Nation UK Limited",
//   "Event name": "Staff Xmas Celebrations 2023",
//   "Event date": "Thursday 14th December 2023",
//   Venue: "Totally Awesome 80s Event",
//   Contact: "Nethelli Ordish",
//   Phone: "",
//   Email: "Nethelli.Ordish@livenation.co.uk",
//   Address: `Live Nation UK Limited
// 30 St John Street,
// London
// EC1M 4AY`,
// };


export const paymentDetails={
  'Minimum number of guaranteed guests':'500',
  'Price per person/Venue Hire Charge':"£150.00 + VAT",
  'In addition client to pay for security officers, Min 5 and then 1 per 100 guests for 8 hour shift, £240 + VAT. £20 per hour thereafter -':'£150.00 + VAT',
  'Toilet Attendant x 1':'£150.00 + VAT',
  'Minimum Cost':'£150.00 + VAT',
  '40% due by Mon, 17 Jul 2023':'£156860.00 + VAT',
  'Balance due no later than Thu, 2 Nov 2023':'£1520.00 + VAT'
}


export const venueArray=[
  {
    heading:'Venue',
    desc:[
      'Exclusive Venue Hire','Complimentary Fully Staffed Cloakroom 2 on site','Professional Event Management and on the night assistance','Atmospheric Lighting throughout venue included','House Table Centres'
    ]
  },
  {
    heading: "Catering",
    desc: [
      "Exclusive Venue Hire",
      "Complimentary fully Staffed cloakroom full 2 on site",
      "Professional Event Management and on the night assistance",
      "Complimentary Fully Staffed Cloakroom 2 on site",
      "Professional Event Management and on the night assistance",
      "Ladies and gentlemen restrooms with hand dryers and sanitisers",
      "Prosecco Reception and non alcoholic drinks for 45 minutes - (if you have the all inclusive drinks package then we will also serve beers, wines and soft drinks) - Bar will be closed when call to dinner is made Unlimited Beers, House Wine & Soft Drinks - includes cider and craft ales in cans",
    ],
  },
  {
    heading: "Entertainment",
    desc: [
      "Exclusive Venue Hire",
      "Complimentary fully Staffed cloakroom full 2 on site",
      "Professional Event Management and on the night assistance",
    ],
  },
]

//INVOICE TAB DATA
export const invoiceFormData = [
  {
    name: 'customer',
    label: 'Customer',
    placeholder: 'Enter Customer Name',
    type: 'textBox',
    isRequired: true
  },
  {
    name: 'invoiceDate',
    label: 'Invoice Date',
    placeholder: 'Invoice Date',
    type: 'date',
    isRequired: true
  },
  {
    name: 'contact',
    label: 'Contact',
    placeholder: 'Contact',
    type: 'textBox',
    isRequired: true
  },
  {
    name: 'dueDate',
    label: 'Due Date',
    placeholder: 'Due Date',
    type: 'date',
    isRequired: true
  },
  {
    name: 'address',
    label: 'Address',
    type: 'addressGroup',
    fields: [
      {
        name: 'addressLine1',
        label: 'Address Line',
        placeholder: 'Enter address line',
        type: 'textBox',
        isRequired: true
      },
      {
        name: 'city',
        label: 'City',
        placeholder: 'Enter city',
        type: 'textBox',
        isRequired: true
      },
      {
        name: 'region',
        label: 'Region',
        placeholder: 'Enter region/state',
        type: 'textBox',
        isRequired: true
      },
      {
        name: 'postalCode',
        label: 'Postal Code',
        placeholder: 'Enter postal code',
        type: 'textBox',
        isRequired: true
      },
      {
        name: 'country',
        label: 'Country',
        placeholder: 'Enter country',
        type: 'textBox',
        isRequired: true
      },
      // Add amount as part of the address group to display it in the same row
      {
        name: 'amount',
        label: 'Amount',
        placeholder: '£0',
        type: 'textBox',
        isRequired: true,
        isSpecialField: true // Add a flag to identify this as a special field
      }
    ]
  },
];
//PRICING TAB DATA
export const pricingTabDetailsInEnquiryCol = [
  {
    id: "name",
    label: "Name",
  },
  { id: "desc", label: "Description" },
  { id: "quantity", label: "Quantity" },
  { id: "price", label: "Price Per unit" },
  { id: "cost", label: "Total Cost to US" },
  { id: "vat", label: "Total Inc VAT" },
  { id: "unitCost", label: "Unit Cost to client" },
  { id: "total", label: "Total cost to client" },
  { id: "totalVat", label: "Total inc vat2" },
  { id: "profitVat", label: "Profit ex vat" },
  { id: "supplierBill", label: "Bill from supplier" },
  { id: "salesInvoice", label: "Sales invoice to client" },
  { id: "action", label: "Action" },
];

export const pricingTabDetailsInEnquiryRow = [
  { 
    id:1,
    name: "Awesome AV",
    desc: "PA system and lighting",
    quantity: "2",
    cost: "£0",
    vat: "£0",
    unitCost: "£0",
    total: "£0",
    totalVat: "£0",
    profitVat: "£0",
    supplierBill: "£0",
    salesInvoice: "£0",
    action: <div className="flex gap-3"><FaEdit/> <IoInformationCircleOutline size={15}/> <FaTrash/></div>,
  },
  {
    id:2,
    name: "Catering Services",
    desc: "green room for speaker to change",
    quantity: "1",
    cost: "£250",
    vat: "£1500",
    unitCost: "£1500",
    total: "£1500",
    totalVat: "£5400",
    profitVat: "£5300",
    supplierBill: "£1500",
    salesInvoice: "£5300",
    action: <div className="flex gap-3"><FaEdit/> <IoInformationCircleOutline size={15}/> <FaTrash/></div>,
  },
  {
    id:3,
    name: "Dukes of Havoc",
    desc: "4 piece band",
    quantity: "2",
    cost: "£250",
    vat: "£500",
    unitCost: "£500",
    total: "£500",
    totalVat: "£5400",
    profitVat: "£5300",
    supplierBill: "£1500",
    salesInvoice: "£5300",
    action: <div className="flex gap-3"><FaEdit/> <IoInformationCircleOutline size={15}/> <FaTrash/></div>,
  },
  {
    id:4,
    name: "Furniture 4 events",
    desc: "chair hire",
    quantity: "2",
    cost: "£250",
    vat: "£500",
    unitCost: "£500",
    total: "£500",
    totalVat: "£5400",
    profitVat: "£5300",
    supplierBill: "£1500",
    salesInvoice: "£5300",
    action: <div className="flex gap-3"><FaEdit/> <IoInformationCircleOutline size={15}/> <FaTrash/></div>,
  },

]; 

export const pricingTabTotalInEnquiryCol=[
  {
    id: "totalCost",
    label: "Total cost to us for event",
  },
  { id: "price", label: "Total price to client" },
  { id: "pricePerGuest", label: "Price Per guest" },
  { id: "margin", label: "Margin" },
  { id: "markUp", label: "Markup" },
  { id: "commission", label: "Commission from hotel" },
  { id: "eventManagement", label: "Event Management fee" },
  { id: "profit", label: "Total profit on this event" },
  { id: "totalVat", label: "Total inc vat2" },
  { id: "profitVat", label: "Profit ex vat" },
  { id: "supplierBill", label: "Bill from supplier" },
  { id: "salesInvoice", label: "Sales invoice to client" },
  { id: "action", label: "Action" },
]

export const pricingTabTotalInEnquiryRow = [
  { 
    id:1,
    totalCost: "£60,940.00",
    price: "£60,940.00",
    pricePerGuest: "£257.76",
    margin: "£13,025.00",
    markUp: "£13,025.00",
    commission: "3776.5",
    eventManagement: "2000",
    profit: "£18,801.50",
    totalVat: "£5400",
    profitVat: "£5300",
    supplierBill: "£1500",
    salesInvoice: "£5300",
    action: <div className="flex gap-3"><FaEdit/> <IoInformationCircleOutline size={15}/> <FaTrash/></div>,
  },
  {
    id:2,
    totalCost: "£47,915.00",
    price: "£60,940.00",
    pricePerGuest: '',
    margin: "",
    markUp: "",
    commission: "",
    eventManagement: "",
    profit: "",
    action:'',
  },

]; 

export  const venueManagement = [
  {
    id: "VenueName",
    label: "Venue Name",
    numeric: false,
    disablePadding: true,
  },
  {
    id: "StandingCapacity",
    label: "Standing Capacity",
    numeric: true,
    disablePadding: false,
  },
  {
    id: "SeatingCapacity",
    label: "Seating Capacity",
    numeric: true,
    disablePadding: false,
  },
  {
    id: "Rooms",
    label: "Rooms",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "ContactPerson",
    label: "Contact Person",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "Location" ,
    label: "Location",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "Actions",
    label: "Actions",
    numeric: false,
    disablePadding: false,
  },
];

export const venueList=[
  {
    id:1,
    VenueName:'The Grand Hall',
    StandingCapacity:"300",
    SeatingCapacity:"600",
    Rooms:'Ball Room, Board Room',
    ContactPerson:'Emma Johnson',
    Location:'California',
    // Actions:<VscHorizontalRule/>
  }
]


export const selectedSupplierList=[
  {
    name:'Catering',
    sublist:['Savory Soiree Catering','Epicurean Delights','Gournments Gatherings']
  },
  {
    name:'Beverages',
    sublist:['Savory Soiree Catering','Epicurean Delights','Gournments Gatherings']
  },
  {
    name:'Audio Visuals',
    sublist:['Savory Soiree Catering','Epicurean Delights','Gournments Gatherings']
  },
  {
    name:'Entertainment',
    sublist:['Savory Soiree Catering','Epicurean Delights','Gournments Gatherings']
  },
  {
    name:'Furniture',
    sublist:['Savory Soiree Catering','Epicurean Delights','Gournments Gatherings']
  }
]

export const scheduleData = [
  { time: "4:00 PM", activity: "Venue Setup", party: "XYZ Hotel Staff", notes: "Ensure all decorations are in place." },
  { time: "6:00 PM", activity: "Guest Arrival", party: "Event Staff", notes: "Welcome drinks (non-alcoholic) to be served" },
  { time: "7:00 PM", activity: "Dinner Service", party: "Catering Team", notes: "Serve three-course meal." },
  { time: "8:00 PM", activity: "Venue Setup", party: "XYZ Hotel Staff", notes: "Ensure all decorations are in place." },
  { time: "9:00 PM", activity: "Guest Arrival", party: "Event Staff", notes: "Welcome drinks (non-alcoholic) to be served" },
  { time: "9:30 PM", activity: "Dinner Service", party: "Catering Team", notes: "Serve three-course meal." },
];


//Supplier's Category data
export const supplierCategoryList=[
  {
    category:'Entertainment',
    subCategory:['DJ','Photobooth','Bands','Show Entertainment','Random','Magician','Casino']
  },
  {
    category:'Photographer',
    subCategory:['Photographers','Videographers','Both']
  },
  {
    category:'Staffing',
    subCategory:['Security','Cleaners','FOH','BOH','Medics','Crew']
  },
  {
    category:'Catering',
    subCategory:['Chefs','Equipment','Food Suppliers','Non-Food Suppliers','External Catering','Alcohol Suppliers','Wholesaler','Linens']
  },
  {
    category:'Temporary Suppliers',
    subCategory:['Bins','Temporary Structures','Marquee','Tent','Containers','Skip Hire','Ped Barriers','Machinery','Toilets','Fuel','Surveyors','Project planning','Plummers','Tills','Consultants','Flooring','Tools']
  },
  {
    category:'Transport',
    subCategory:['Specialist Shipping','Couriers','Car hire','Van Hire','Bus Hire','Chauffers','Import/Export']
  },
  {
    category:'Production/AV',
    subcategory:['Technicians','Suppliers','Stages','Screens','Lighting','Rigging','Sound']
  },
  {
    category:'Furniture',
    subCategory:['Tables','Chairs','Bars','Soft Furnishing']
  },
  {
    category:'Theming',
    subCategory:['Prop Hire','Draping','Table centres']
  },
  {
    category:'IT',
    subCategory:['Support','Website','Rendering']
  },
  {
    category:'Marketting/ Exhibition',
    subCategory:['Ticketing Websites','Social Media']
  },
  {
    category:'Office',
    subCategory:['Supplies']
  }
]

//CLIENT MANAGEMENT TAB DATA
export const additionalInfoFormData = [
  {
    name: "children",
    label: "Children",
    type: "textBox",
    placeholder: "Enter Children Name",
  },
  {
    name: "birthday",
    label: "Birthday",
    type: "date",
    placeholder: "Enter Birthday",
  },
  {
    name: "holidays",
    label: "Holiday",
    type: "textBox",
    placeholder: "Enter Holiday",
  },
  {
    name: "industry",
    label: "Industry",
    type: "textBox",
    placeholder: "Enter Industry",
  },
  {
    name: "hobbies",
    label: "Hobbies",
    type: "textBox",
    placeholder: "Enter Hobbies",
  },
  {
    name: "pets",
    label: "Pets",
    type: "textBox",
    placeholder: "Enter Pets",
  },
  {
    name: "interests",
    label: "Interests",
    type: "textBox",
    placeholder: "Enter Interests",
  },
  {
    name: "age",
    label: "Age",
    type: "number",
    placeholder: "Enter Age",
  },
  {
    name: "additionalNotes",
    label: "Additional Notes",
    type: "textArea",
    placeholder: "Enter Additional Notes",
  },
];

export const clientmanagementEmployeeInfoFormData = [
  {
    name: "salutation",
    label: "Title",
    type: "select",
    placeholder: "Select Salutation",
  },
  {
    name: "firstName",
    label: "First Name",
    type: "textBox",
    placeholder: "Enter Name",
    required: true,
  },
  {
    name: "lastName",
    label: "Last Name",
    type: "textBox",
    placeholder: "Enter last Name",
  },
  // {
  //   name: "address",
  //   label: "Address",
  //   type: "textArea",
  //   placeholder: "Enter Address",
  //   required: true,
  // },
  {
    name: "email",
    label: "Email",
    type: "textBox",
    placeholder: "Enter Email",
    required: true,
  },
  {
    name: "phoneNumber",
    label: "Mobile Number",
    type: "textBox",
    placeholder: "Enter Phone",
    required: true,
  },
  {
    name: "position",
    label: "Position",
    type: "textBox",
    placeholder: "Enter Position",
  },
  {
    name: "companyId",
    label: "Company",
    type: "select",
    placeholder: "Select Company",
    required: true,
  },
  
];

export   const eventColumns: eventCol[] = [
  {
    id: "firstName",
    label: "Client Name",
  },
  { id: "email", label: "Email" },
  { id: "phoneNumber", label: "Phone" },
  { id: "Actions", label: "Action" },
];

export const associatedEventColumns: eventCol[] = [
  // {
  //   id: "eventName",
  //   label: "Event Title",
  // },
  { id: "eventType", label: "Event Title" },
  { id: "createdAt", label: "Proposed date" },
  { id: "budget", label: "Budget" },
  { id: "assignedTo", label: "Assigned person" },
];


export const eventStatusColumns = [
  {
    id: "eventType" as keyof EventStatus,
    label: "Event Name",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "eventDate" as keyof EventStatus,
    label: "Event Date",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "customerName" as keyof EventStatus,
    label: "Client Name",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "budget" as keyof EventStatus,
    label: "Event Budget",
    numeric: true,
    disablePadding: false,
  },
  {
    id: "assignedSalesPersonName" as keyof EventStatus,
    label: "Assigned Member",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "salesStatus" as keyof EventStatus,
    label: "Status",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "Actions" as keyof EventStatus,
    label: "Actions",
    numeric: false,
    disablePadding: false,
    isSticky: true,
    stickyPosition: "right",
  },
];
export const salesPerformanceColumns = [
  {
    id: "assignedSalesPersonName" as keyof SalesPerformanceStatus,
    label: "SalesPerson Name",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "customerName" as keyof SalesPerformanceStatus,
    label: "Client Name",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "eventType" as keyof SalesPerformanceStatus,
    label: "Event Name",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "eventDate" as keyof SalesPerformanceStatus,
    label: "Event Date",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "budget" as keyof SalesPerformanceStatus,
    label: "Event Budget",
    numeric: true,
    disablePadding: false,
  },

  {
    id: "salesStatus" as keyof SalesPerformanceStatus,
    label: "Status",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "Actions" as keyof SalesPerformanceStatus,
    label: "Actions",
    numeric: false,
    disablePadding: false,
    isSticky: true,
    stickyPosition: "right",
  },
];
export const handledEventColumns = [
  {
    id: "eventType" as keyof HandledEvent,
    label: "Event Name",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "totalExpense" as keyof HandledEvent,
    label: "Total Budget",
    numeric: true,
    disablePadding: false,
  },
  {
    id: "totalProfit" as keyof HandledEvent,
    label: "Total Profit",
    numeric: true,
    disablePadding: false,
  },
  {
    id: "contractSentCount" as keyof HandledEvent,
    label: "No of Event Contract",
    numeric: true,
    disablePadding: false,
  },
  {
    id: "proposalCount" as keyof HandledEvent,
    label: "Proposal Sent",
    numeric: true,
    disablePadding: false,
  }
];

export const reportColumns = [
  {
    id: "userName" as keyof UserData,
    label: "User Name",
    numeric: true,
    disablePadding: false,
  },
  {
    id: "emailAddress" as keyof UserData,
    label: "Email Address",
    numeric: true,
    disablePadding: false,
  },
  {
    id: "phoneNumber" as keyof UserData,
    label: "Phone Number",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "role" as keyof UserData,
    label: "Role",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "joinedDate" as keyof UserData,
    label: "Joined Date",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "Actions" as keyof UserData,
    label: "Actions",
    numeric: false,
    disablePadding: false,
  },
];

export const reportProfitColumn = [
  {
    id: "eventName" as keyof ReportProfit,
    label: "Event Name",
    numeric: true,
    disablePadding: false,
  },
  {
    id: "revenue" as keyof ReportProfit,
    label: "Total Revenue",
    numeric: true,
    disablePadding: false,
  },
  {
    id: "expensive" as keyof ReportProfit,
    label: "Total Expenses",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "profit" as keyof ReportProfit,
    label: "Total Profit",
    numeric: false,
    disablePadding: false,
  },
  {
    id: "loss" as keyof ReportProfit,
    label: "Total Loss",
    numeric: false,
    disablePadding: false,
  },
];


export const truncateFileName = (name: any, maxLength = 20) => {
  if (name.length <= maxLength) return name;
  const ext = name.substring(name.lastIndexOf("."));
  const prefix = name.substring(0, maxLength - ext.length - 5); // keep start
  return `${prefix}...${ext}`;
}

export const STATUS_LABEL_MAP: any = {
  new: "New Enquiries",
  contacted: "Contacted",
  meeting: "Meeting",
  proposal_sent: "Proposals Sent",
  site_visit: "Site Visits Booked",
  negotiating: "Neogtiating",
  contract_sent: "Contract Sent",
  confirmed: "Booked events",
};

export const navArray = [
  {
    id: 1,
    moduleName: "Dashboard",
    toolTipName: "Dashboard",
    menuImg: dashBoardIcon,
    route: "/dashboard",
    label: "dashboard",
  },
  {
    id: 2,
    moduleName: "User Management",
    toolTipName: "User Management",
    menuImg: userMangeIcon,
    route: "/user-list",
    label: "user-list",
  },
  {
    id: 3,
    moduleName: "Enquiries",      //"Enquries",
    toolTipName: "Enquiries",
    menuImg: enqueryIcon,
    route: "/enquiries-list",
    label: "enquiries-list",
  },
  {
    id: 4,
    moduleName: "Event Planning",
    toolTipName: "Event Planning",
    menuImg: eventIcon,
    route: "/event-list",
    label: "event-list",
  },
  {
    id: 5,
    moduleName: "Supplier Management",
    toolTipName: "Supplier Management",
    menuImg: supplierIcon,
    route: "/supplier-list",
    label: "supplier-list",
  },
  {
    id: 6,
    moduleName: "Venue Management",
    toolTipName: "Venue Management",
    menuImg: venueIcon,
    route: "/venue-list",
    label: "venue-list",
  },
  {
    id: 7,
    moduleName: "Customer Management",
    toolTipName: "Customer Management",
    menuImg: customerIcon,
    route: "/customer-list",
    label: "customer-list",
  },
  {
    id: 8,
    moduleName: "Reports",
    toolTipName: "Reports",
    menuImg: reportIcon,
    route: "/report-management",
    label: "report-management",
  },
  {
    id: 9,
    moduleName: "Payments",
    toolTipName: "Payments",
    menuImg: paymentIcon,
    route: "/payments",
    label: "payments",
  },
  {
    id: 10,
    moduleName: "Settings",
    toolTipName: "Setting",
    menuImg: settingIcon,
    route: "/settings",
    label: "settings",
  },
];

export const labels = [
  "New",
  "Contacted",
  "Meeting",
  "Proposal Sent",
  "Site Visit",
  "Negotiating",
  "Contract Sent",
  "Contract Signed",
];

export const statusMapping: { [key: string]: number } = {
  "NEW": 1,
  "CONTACTED": 2,
  "MEETING": 3,
  "PROPOSAL SENT": 4,
  "SITE VISIT": 5,
  "NEGOTIATING": 6,
  "CONTRACT SENT": 7,
  "CONTRACT SIGNED": 8,
};

// Transform the status to match the mapping
export const transformStatus = (status: string): string => {
const statusMap: { [key: string]: string } = {
    "new": "NEW",
    "contacted": "CONTACTED",
    "meeting": "MEETING",
    "proposal_sent": "PROPOSAL SENT",  // Convert underscore to space
    "site_visit": "SITE VISIT",
    "negotiating": "NEGOTIATING",
    "contract_sent": "CONTRACT SENT",
    "confirmed": "CONTRACT SIGNED",
};
return statusMap[status?.toLowerCase()] || "";
};
